import { faTimesCircle } from '@fortawesome/pro-solid-svg-icons'

import {
  Box, Checkbox, FormField, ListItem, Tag, Text,
} from '@domain-group/suit-theme'

import type { TaskListItemModel } from '@domain-group/realhub-backend-api-types'

import useTaskListItem, { useTaskListItemForm } from '@hooks/useTaskListItem'

interface TaskListItemProps {
  disabled?: boolean,
  taskListItem: TaskListItemModel,
}

const TaskListItem = (props: TaskListItemProps) => {
  const { disabled, taskListItem } = props

  const taskListItemPayload = useTaskListItem(taskListItem)
  const {
    callbacks: {
      updateTaskListItem,
    },
    taskListItem: {
      assigned_points, description, title,
    },
  } = taskListItemPayload

  const taskListItemForm = useTaskListItemForm(taskListItem)
  const {
    entityState: {
      notes,
    },
    handlers: {
      onChange,
    },
  } = taskListItemForm

  return (
    // @ts-expect-error TS2339
    <ListItem.WithCheckbox
      boxProps={{
        alignItems: 'center',
        borderBottom: '1px dashed',
        fontSize: 'small',
        paddingX: 'large',
        paddingY: 'medium',
      }}
      checkbox={
        <Checkbox checked color="red" fontSize="small" iconChecked={faTimesCircle} style={{ cursor: 'default' }} />
      }
      disableHover
      secondaryText={description}
      showCheckbox
      title={title}
    >
      <Box flexDirection="column">
        <Box alignItems="center">
          <Box flexDirection="column" width="auto">
            <Text>{title}</Text>

            {!!description && (
              <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="small">
                {description}
              </Text>
            )}
          </Box>

          {!!assigned_points && (
            <Tag
              boxProps={{
                color: 'bodyFontColor',
                display: 'inline-flex',
                fontSize: 'xxsmall',
                fontStyle: 'normal',
                marginLeft: 'auto',
                paddingX: 'medium',
                variant: 'whiteGrey',
              }}
              // @ts-expect-error TS2322
              width="auto"
            >
              {assigned_points} Points
            </Tag>
          )}
        </Box>

        {(!disabled || !!notes) && (
          <Box marginTop="medium">
            <FormField>
              <textarea
                disabled={disabled}
                name="notes"
                onBlur={e => updateTaskListItem({ id: taskListItem.id, notes: e.target.value })}
                // @ts-expect-error TS2322
                onChange={onChange}
                style={{ height: 60 }}
                value={notes}
              />
            </FormField>
          </Box>
        )}
      </Box>
    {/*
     // @ts-expect-error TS2339 */}
    </ListItem.WithCheckbox>
  )
}

export default TaskListItem
